import { render, staticRenderFns } from "./CustomElementRender.vue?vue&type=template&id=a261c93e&"
import script from "./CustomElementRender.vue?vue&type=script&lang=js&"
export * from "./CustomElementRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports